import styled from 'styled-components';

import { GRADIENTS, HOME } from '../../../../theme/tokens';

/** Single stacked column inner panel (no chart). */
export const Inner = styled.div`
  background: ${HOME.panel};
  border-radius: 16px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${GRADIENTS.dividerStyledH};
`;

export const SplitRow = styled.div`
  display: flex;
  gap: 24px;
`;
